module.exports = __webpack_public_path__ + "img/play-button.cfccda6e.svg";